import React from 'react'

export default function Error(props) {
    

    return (
        <div className='err'>
            
        </div>
    )
}
